import { render, staticRenderFns } from "./areaDanke.vue?vue&type=template&id=012aed1e"
import script from "./areaDanke.vue?vue&type=script&lang=js"
export * from "./areaDanke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports